// Path: src\Components\GameType\GameType.jsx
import React, { useEffect, useState } from 'react'
import BaseHome from '../Home/BaseHome'
import { useTranslation } from 'react-i18next'
import Button from '../CommonFields/Button'
import ButtonPrivate from '../CommonFields/PrivateContestButton'
import Game from "../../images/box.png";
import HowToJoin from "../../assets/images/howtojoin.svg";
import HostNow from "../../assets/images/hostnow.svg";

import { useNavigate } from "react-router";
import { gameTypeList } from "../../api/gameType.api";
import { getUserInGameName } from "../../api/userInGameName.api";
import { url } from "../../config/url";

import HowToJoinPage from '../HowToJoin/HowToJoin';
import BasePopup from "../Popup/BasePopup";
import TextInput from '../CommonFields/TextInput';

import UserInGameNamePopUp from '../UserInGameName/UserInGameName';
import { routesFrontend } from '../RouterFiles/routes'
import ListLoader from '../Common/ListLoader'
import { useParams } from "react-router";

export const initialFilter = {
  pagination: {
    sortBy: "order",
    sortDirection: "asc"
  },
  search: {
    gameId: null
  }
};

const GameType = () => {
  const { t } = useTranslation()
  const navigate = useNavigate();
  // Example URL: http://localhost:3000/game-type/637f4e7adad1874c4b2f7292
  // Get gameId from route params
  const params2 = useParams();
  const gameId = params2?.id
  console.log("gameId", params2)
  // const gameName = localStorage.getItem("activeGame");

  const [filter, setFilter] = useState(initialFilter);
  const [list, setList] = useState([]);
  const [isTournament, setIsTournament] = useState(false);
  const [tournamentInfo, setTournamentInfo] = useState({});
  const [loading, setLoading] = useState(true);
  const [isHowToJoin, setIsHowToJoin] = useState(false);
  const [gameName, setGameName] = useState("");
  const [inGameNamePopup, setinGameNamePopup] = useState(false);


  console.log(list)
  console.log(isTournament)

  useEffect(() => {
    setLoading(true)
    let tempFilter = {
      pagination: {
        sortBy: "order",
        sortDirection: "asc"
      },
      "search": { gameId: gameId }
    };
    // tempFilter.search.gameId = gameId;
    setFilter(tempFilter);
    fetchGameTypes(tempFilter);
  }, [gameId])

  const fetchGameTypes = async (tempFilter) => {
    try {
      const res = await gameTypeList(tempFilter);
      if (res?.success && res?.data) {
        setList(res?.data)
        setGameName(res?.gameName);
        setIsTournament(res?.tournament?.isTournament || false)
        setTournamentInfo(res?.tournament?.tournamentImage || {})
      }
      else {
        setList([]);
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)

    }
  };

  const openInGameNamePopUp = () => {
    if (!inGameNamePopup) {
      setinGameNamePopup(true)
    }
    else {
      setinGameNamePopup(false)
    }
  }

  const openContestList = (value, name) => {
    localStorage.setItem("activeGameTypeId", value)
    localStorage.setItem("activeGameTypeName", name)
    navigate('/contest/list')
  }


  return (
    !isHowToJoin ?
      <BaseHome title={gameName||""} onBackClick={() => {
        navigate(`/home`);
      }}>
        <div style={{ paddingBottom:"5.5rem" }}>
        <section className='w-100 d-flex justify-content-center'>
          <div className='htj-btn' onClick={() => setIsHowToJoin(true)} style={{fontSize:"15px"}}>
            <span className='me-2'>
              <img className='icon-20' src={HowToJoin} />
            </span>
            {t('how_to_join?')}
          </div>
        </section>
        <section className="renew-box mt-4 d-flex">
          <div className="first hostNow">
            <div>
              <span>
                <img src={HostNow} />
              </span>
            </div>
          </div>
          <div className="second " style={{display:"flex",alignItems:"center",marginBottom:"0px"}}>
            <h6 className='mb-1 me-4'>
              {t("gametype.host_your_own_scrims")}
            </h6>

          </div>
          <div className="third">
            {/* <Button text="host now"></Button> */}
            <button className='host-now' onClick={() => navigate('/' + routesFrontend.privateScrim + '/' + routesFrontend.privateScrimList)}>
             {t("gametype.hostnow")}
            </button>
          </div>

        </section>
        <section style={{ marginBottom: "20px"}}>
          <div className='mt-4 d-flex flex-wrap game-type scroll-none'>
            {isTournament && (
              <div className="game-box" onClick={() => navigate('/tournament/list')}>
                <div className="px-1 pb-1 text-center">
                  <span>{t('tournaments')}</span>
                </div>
                <div className="home-game">
                  <div className="overlay">
                    <img src={url?.IMAGE_URL + tournamentInfo?.default} alt="Tournament" />
                  </div>
                </div>
              </div>
            )}
            {loading && <div className='w-100 d-flex justify-content-center'> <ListLoader /></div>}
            {list && list.length > 0 ? (
              list.map((data, indp) => (
                <div className="game-box" onClick={() => { openContestList(data?._id, data?.name); }} key={indp}>
                  <div className="px-1 pb-1 text-center">
                  <span>
                  {data?.name?.length > 10 ? (
                          <marquee>{data?.name.toLocaleLowerCase()}</marquee>
                        ) : (
                          data?.name.toLocaleLowerCase()
                        )}
                        </span>
                   {/* <span> {data?.name?.toLocaleLowerCase()}</span> */}
                  </div>
                  <div className="home-game">
                    <div className="overlay">
                      <img src={url?.IMAGE_URL + data?.displayImage} alt={data?.name} />
                    </div>
                  </div>
                </div>
              ))
            ) : (!loading && !isTournament && (!list || list.length === 0)) ? (
              <div className="d-flex justify-content-center w-100">
                <div className="no-record-found-center" style={{height:"50vh"}}>
                  <span>{t('common.no_data_found')}</span>
                </div>
              </div>
            ) : null}
          </div>
        </section>

        <section className='text-center mt-5'>
            <p className='mb-0 text-white'>{t('wantToaddInGameName', { gameName: gameName })}</p>
          <p className='active clickhere mb-0' onClick={() => openInGameNamePopUp()}> {t('clickHere')} </p>
          <div className='mt-3'>
          <div className="custome-common-btn-bottom">
            <Button onClick={() => navigate(`/my-contest/list/${gameId}`)} text={t('myContest')} />
              </div>
          </div>
          {/* <div className='mt-3'>
            <ButtonPrivate text="host private contest" onClick={()=>navigate('/'+routesFrontend.privateScrim + '/' + routesFrontend.privateScrimList)}/>
          </div> */}
        </section>

        {inGameNamePopup && (
          <UserInGameNamePopUp inGameNamePopup={inGameNamePopup} setinGameNamePopup={setinGameNamePopup} />
        )}
</div>

      </BaseHome>
      :
      <HowToJoinPage onBackClick={() => setIsHowToJoin(false)} />
  )
}

export default GameType